module.exports = __webpack_public_path__ + "static/index/img/baikal-611.0f0b26f1.jpg";